module.exports = __webpack_public_path__ + "static/img/07-modern-S.88b8898.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/07-modern-S.jpg
// module id = arHz
// module chunks = 12